import { useStore } from '@stores';
import { useEffect } from 'react';

export const useInventoryCategories = () => {
  const { inventoryStore } = useStore();

  useEffect(() => {
    inventoryStore.getAllCategories();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    categories: inventoryStore.categories,
    options: inventoryStore.categories.map((c) => ({ label: c.name, value: c.id })),
  };
};
